import { useMemo } from 'react';
import { useUserIdSelector } from '../../../store/userData/userData.selectors';
import { StorageService } from './storageService';

export const useStorageService = () => {
  const userId = useUserIdSelector();

  return useMemo(() => new StorageService(userId), [userId]);
};
